import { AuthService, type PasswdBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: PasswdBodyDto;
};

export const resetPassword = ({ call, requestBody }: TParams) =>
  call(() => AuthService.passwd({ requestBody }), { dontCatchErrors: true });
